export default __webpack_public_path__ + "static/media/logo.6272e688.svg";